export default "/_next/static/chunks/fonts/Arvo-Bold-latin-b33ef8ff19efec4ac1d9273620f61300.woff2";